import {PropertyBase} from "./PropertyBase";
import {Input} from "postcss";
import * as React from "react";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {library} from "@fortawesome/fontawesome-svg-core";
import {faLock} from "@fortawesome/free-solid-svg-icons/faLock";
import {faLockOpen} from "@fortawesome/free-solid-svg-icons/faLockOpen";
let Switch=require('react-switch').default;

library.add(faLock);
library.add(faLockOpen);
export class SwitchProperty extends PropertyBase{
    public label:string="Label";
    private convertToPixels:boolean=true;
    private _placeholder: string;

    public SetPlaceholder(placeholder:string){
        this._placeholder=placeholder;
        return this;
    }
    public SetDoNotConvertToPixels()
    {
        this.convertToPixels=false;
    }

    public SubRenderer(): React.ReactNode {
        let value:any=parseInt(this.GetOptionValue());
        if(isNaN(value))
            value='';
        return (
            <div>
                <label style={{width:'100%'}}>{this.label}</label>
                <Switch onColor={'#ff0000'} onChange={e=>this.Changing(e)} checked={this.GetBooleanValue(this.OptionsPropertyName)} checkedIcon={this.CreateContainer(<FontAwesomeIcon icon={'lock'} />)}  uncheckedIcon={this.CreateContainer(<FontAwesomeIcon icon={'lock-open'} />)}/>
            </div>
        )
    }

    private Changing(e: any) {
        this.SetOptionValue(e,this.OptionsPropertyName)
    }

    private CreateContainer(container:any) {
        return (
            <div style={{height:'100%',display:'flex',alignItems:'center',justifyContent:'center',color:'white'}}>{container}</div>
        )
    }
}